const Pagamento = () => import('../../spa/pagamento/Pagamento');

export default {
  path: 'pagamento',
  name: 'pagamento',
  component: Pagamento,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/pagamento.js